import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import axios from "axios";
import swal from "sweetalert2";
import { globalState, accessTokenKey, baseUrl, isPremium, premiumMessage } from "../utils/config";

import Loader from "./layouts/Loader";
import imagePlaceholder from "../assets/img/user-placeholder.png";

function Inbox() {
    const messagesRef = useRef(null);
    const [state, setState] = useState(globalState.state);
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState("");
    const [selectedUser, setSelectedUser] = useState(null); 
    const [messages, setMessages] = useState([]);
    const [messageInput, setMessageInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadingMessages, setLoadingMessages] = useState(false);
    const [refetchUsers, setRefetchUsers] = useState(1);
    const [refetchMessages, setRefetchMessages] = useState(1);
    const [messagesPage, setMessagesPage] = useState(1);
    const [page, setPage] = useState(1);
    const [sendingMessage, setSendingMessage] = useState(false);
    const [timer, setTimer] = useState(null);

    const handleSelectUser = (user) => {
        setSelectedUser(user);
    };

    const handleSendMessage = async function () {
        if (!messageInput.trim()) return;

        if (selectedUser == null) {
            alert("Please select a user first.");
            return;
        }
        
        setSendingMessage(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("time_zone", timeZone);
            formData.append("user_id", selectedUser.id);
            formData.append("message", messageInput);
           
            const response = await axios.post(
                baseUrl + "/api/messages/send",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const messageObj = response.data.message_obj;
                const msgs = [ ...messages ];
                msgs.push(messageObj);
                setMessages(msgs);
                setMessageInput("");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setSendingMessage(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSendMessage();
    };

    async function fetch() {
        setLoading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("time_zone", timeZone);
            formData.append("search", search);
           
            const response = await axios.post(
                baseUrl + "/api/messages/fetch-users",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setUsers(response.data.users);
            } else {
                // swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    async function fetchMessages() {
        if (selectedUser == null) {
            alert("Please select a user first.");
            return;
        }

        setLoadingMessages(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("time_zone", timeZone);
            formData.append("user_id", selectedUser.id);
            formData.append("page", messagesPage);
           
            const response = await axios.post(
                baseUrl + "/api/messages/fetch",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setMessages(response.data.messages);

                setTimeout(function () {
                    if (messagesPage == 1) {
                        if (messagesRef.current) {
                            messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
                        }
                    }
                }, 500);

                let unreadCountReduced = 0;
                for (let a = 0; a < users.length; a++) {
                    if (users[a].id == selectedUser.id) {
                        unreadCountReduced = users[a].unread_count;
                        users[a].unread_count = 0;
                        break;
                    }
                }
                setUsers(users);

                globalState.setState({
                    newMessages: state.newMessages - unreadCountReduced
                });
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoadingMessages(false);
        }
    }

    useEffect(function () {
        if (selectedUser != null) {
            fetchMessages();
        }
    }, [selectedUser, refetchMessages]);

    useEffect(function () {
        fetch();
    }, [refetchUsers]);

    useEffect(function () {
        globalState.listen(function (fullState, updatedState) {
            setState(fullState);
        });
    }, []);

    const styles = {
        unreadCount: {
            position: "absolute",
            right: "10px"
        },
        profileImage: {
            width: "50px",
            height: "50px",
            objectFit: "cover",
            borderRadius: "50%",
            marginRight: "10px"
        }
    };

    return (
        <>
            <div className={ isPremium ? "" : "blur-overlay" }>
                { !isPremium && (
                    <div className="blur-message">
                        <p>{ premiumMessage }</p>
                    </div>
                ) }

                <div className="chat-container">
                    <div className="user-list">

                        { loading && (
                            <div className="row mt-3 mb-3">
                                <div className="offset-md-4 col-md-3">
                                    <Loader />
                                </div>
                            </div>
                        ) }

                        <input
                            type="text"
                            placeholder="Search users..."
                            value={ search }
                            onChange={ function (e) {
                                setSearch(e.target.value);

                                clearTimeout(timer);

                                setTimer(setTimeout(function () {
                                    setRefetchUsers(refetchUsers + 1);
                                }, 500));
                            } }
                        />

                        { users.map(function (u, index) {
                            return (
                                <div
                                    key={ u.id }
                                    className={ `user ${ u.id === selectedUser?.id ? 'active' : '' }` }
                                    onClick={ function () {
                                        handleSelectUser(u);
                                    } }>

                                    { u.profile_image ? (
                                        <img src={ u.profile_image }
                                            style={ styles.profileImage } />
                                    ) : (
                                        <img src={ imagePlaceholder }
                                            style={ styles.profileImage } />
                                    ) }

                                    { u.name }

                                    { u.unread_count > 0 && (
                                        <span className="text-danger"
                                            style={ styles.unreadCount }>
                                            &nbsp;
                                            ({ u.unread_count })
                                        </span>
                                    ) }
                                </div>
                            );
                        }) }
                    </div>

                    <div className="chat-box">
                        <div className="chat-header">
                            { selectedUser != null && (
                                <div>
                                    { selectedUser.profile_image ? (
                                        <img src={ selectedUser.profile_image }
                                            style={ styles.profileImage } />
                                    ) : (
                                        <img src={ imagePlaceholder }
                                            style={ styles.profileImage } />
                                    ) }

                                    { selectedUser.type == "job_seeker" ? (
                                        <Link to={ `/user/${ selectedUser.id }` }>{ selectedUser.name || "" }</Link>
                                    ) : selectedUser.type == "recruiter" && (
                                        <Link to={ `/recruiter/${ selectedUser.id }` }>{ selectedUser.name || "" }</Link>
                                    ) }
                                </div>
                            ) }
                        </div>

                        <div className="chat-messages" ref={ messagesRef }>

                            { loadingMessages && (
                                <div className="row mt-3 mb-3">
                                    <div className="offset-md-6 col-md-3">
                                        <Loader />
                                    </div>
                                </div>
                            ) }

                            { messages.map((msg, index) => (
                                <div key={ index } className={`message ${ msg.sender_id == state.user?.id ? "self" : "other" }`}>
                                    { msg.message }
                                </div>
                            )) }
                        </div>

                        <div className="chat-input">
                            <input
                                type="text"
                                placeholder="Type your message..."
                                value={messageInput}
                                onChange={(e) => setMessageInput(e.target.value)}
                                onKeyDown={handleKeyDown}
                            />
                            <button onClick={handleSendMessage}
                                disabled={ sendingMessage }>Send</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Inbox;